import "../scss/style.scss";
import $ from 'jquery';
import 'slick-carousel';
import "./slik.js";
import nodeMarquee from 'node-marquee';
import "./animation.js"
import "./lib/ofi.min.js";

// marquee
$(function () {
  nodeMarquee({
    parent: '#node-marquee'
  });
});

// anker link
// $(window).on('load', function() {
//   const speed = 180;
//   const href = window.location.hash;
//   const target = $(href === '#' || href === '' ? 'html' : href);
//   if (target.length) {
//     let position = target.offset().top - $('.js-header').outerHeight();
//     $('html, body').animate({ scrollTop: position }, speed, 'swing');
//   }
// });

$(function () {
    var _window = $(window), _navBt = $('.js-nav-btFixed'), _navContent = $('.js-nav-contentFixed'), heroBottom;

    _window.on('scroll',function(){
    heroBottom = $('.js-nav-trigger').height();
    if(_window.scrollTop() + 60 > heroBottom){
      _navBt.addClass('navBt02');
      _navContent.addClass('header02');
    }
    else{
      _navBt.removeClass('navBt02');
      _navContent.removeClass('header02');
    }
  });

  _window.trigger('scroll');
});

// SP nav
$(document).ready(function () {
  $('.js-nav-bt').on('click', function () {
    if ($('.js-nav-content').hasClass('close')) {
      $(".js-nav-content").removeClass('close');
      $(this).removeClass('close');
    } else {
      $(".js-nav-content, .js-nav-logoLink").addClass('close');
      $(this).addClass('close');
    }
  });
  $('.js-nav-bt.close, .js-nav-link, .js-nav-logoLink').on('click', function () {
    $(".js-nav-content, .js-nav-bt.close").removeClass('close');
    $(".js-nav-content, .js-nav-bt.close").removeClass('close');
  });
});

//modal
$(function() {
  $('.js-modalBt').on('click', function() {
    let target = $(this).data('modal-link');
    let modal = document.querySelector('.' + target);
    $(modal).toggleClass('is-on');
  });
    $('.js-modal-close').on('click', function() {
    $(this).parents('.js-modal').toggleClass('is-on');
  });
});

//pullDown
jQuery(function($) {
  $('.js-pullDown').on('click', function () {
    $(this).next().slideToggle();
    $(this).toggleClass('is-on');
  });
});
